export const TKeyCredits = {
  CREDITS_SHARED_TITLE: "CREDITS_SHARED_TITLE",
  CREDITS_SHARED_TEXT: "CREDITS_SHARED_TEXT",
  CREDITS_BUY: "CREDITS_BUY",
  CREDITS_LABEL: "CREDITS_LABEL",
  CREDITS_TOTAL_HT: "CREDITS_TOTAL_HT",
  CREDITS_PACK_SELECT: "CREDITS_PACK_SELECT",
  CREDITS_CHOOSE_PACK: "CREDITS_CHOOSE_PACK",
  SUBSCRIPTION_STATUS_PAST_DUE: "SUBSCRIPTION_STATUS_PAST_DUE",
  BUY_PLAN_START: "BUY_PLAN_START",
  BUY_PLAN_FEATURE_CALLS: "BUY_PLAN_FEATURE_CALLS",
  BUY_PLAN_FEATURE_PROSPECTS: "BUY_PLAN_FEATURE_PROSPECTS",
  BUY_PLAN_FEATURE_REST: "BUY_PLAN_FEATURE_REST",
  BILLING_CUSTOM_PLAN: "BILLING_CUSTOM_PLAN",
  BILLING_MANAGE_LINK: "BILLING_MANAGE_LINK",
  TOPUP_TITLE: "TOPUP_TITLE",
  TOPUP_AMOUNT: "TOPUP_AMOUNT",
  TOPUP_HINT_CALLS: "TOPUP_HINT_CALLS",
  TOPUP_HINT_PROSPECTS: "TOPUP_HINT_PROSPECTS",
  TOPUP_LEFT: "TOPUP_LEFT",
  TOPUP_RENEWS_ON: "TOPUP_RENEWS_ON",
  TOPUP_ENDS_ON: "TOPUP_ENDS_ON",
  TOPUP_NEVER_EXPIRES: "TOPUP_NEVER_EXPIRES",
  PLAN_NAME_PRO: "PLAN_NAME_PRO",
  PLAN_NAME_TRIAL: "PLAN_NAME_TRIAL",
  PLAN_NAME_NONE: "PLAN_NAME_NONE",
  PLAN_LABEL: "PLAN_LABEL",
  PLAN_USAGE_CALLS: "PLAN_USAGE_CALLS",
  PLAN_USAGE_PROSPECTS: "PLAN_USAGE_PROSPECTS",
  PLAN_MANAGE: "PLAN_MANAGE",
  PLAN_SEE_PLANS: "PLAN_SEE_PLANS",
  CREDITS_PLAN_LABEL: "CREDITS_PLAN_LABEL",
  CREDITS_HOURS_SHORT: "CREDITS_HOURS_SHORT",
  CREDITS_PROSPECTS_SHORT: "CREDITS_PROSPECTS_SHORT",
  CREDITS_WALLET_TOOLTIP: "CREDITS_WALLET_TOOLTIP",
  SUBSCRIPTION_STRIPE_PRODUCT_NAME: "SUBSCRIPTION_STRIPE_PRODUCT_NAME",
  SUBSCRIPTION_STRIPE_PRODUCT_DESCRIPTION: "SUBSCRIPTION_STRIPE_PRODUCT_DESCRIPTION",
  CREDITS_STRIPE_PRODUCT_NAME: "CREDITS_STRIPE_PRODUCT_NAME",
  CREDITS_STRIPE_PRODUCT_NAME_PROSPECTS: "CREDITS_STRIPE_PRODUCT_NAME_PROSPECTS",
  TOPUP_TAB_CALLS: "TOPUP_TAB_CALLS",
  TOPUP_TAB_PROSPECTS: "TOPUP_TAB_PROSPECTS",
  TOPUP_PROSPECTS_UNIT: "TOPUP_PROSPECTS_UNIT",
  CREDITS_STRIPE_PRODUCT_DESCRIPTION: "CREDITS_STRIPE_PRODUCT_DESCRIPTION",
  CREDITS_PROJECT_ANALYZED_TOTAL: "CREDITS_PROJECT_ANALYZED_TOTAL",
  CREDITS_EXAMPLE_CALL: "CREDITS_EXAMPLE_CALL",
  CREDITS_EXAMPLE_PROSPECT: "CREDITS_EXAMPLE_PROSPECT",
  CREDITS_EXAMPLE_PER_HOUR: "CREDITS_EXAMPLE_PER_HOUR",
  CREDITS_EXAMPLE_PER_PROSPECT: "CREDITS_EXAMPLE_PER_PROSPECT",
  CREDITS_PORTAL: "CREDITS_PORTAL",
  CREDITS_EXAMPLE_POOL: "CREDITS_EXAMPLE_POOL",
  CREDITS_EXAMPLE_PER_PROFILE: "CREDITS_EXAMPLE_PER_PROFILE",
} as const;
